import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

import TressProductTile from "@/components/TressProductTile.vue";
import { PropType } from "vue";
import { ProductTile } from "@/models/ProductList";
import { TileType } from "@/enums/TileType";
import { IProductContentTile } from "@/models/IProductContentTile";
import TressProductContentTile from "@/components/TressProductContentTile.vue";
import { IIndexTile } from "@/models/IIndexTile";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressProductListings',
  props: {
  content: {
    type: Object as PropType<Array<IIndexTile>>,
    required: true,
  },
  showAsB2b: {
    type: Boolean,
    required: true,
  },
  parent: {
    type: String,
    required: true,
  },
  blueSiteLogotype: {
    type: String,
    required: false,
  },
  fastDeliveryLogotype: {
    type: String,
    required: false,
  },
  fastDeliveryAltText: {
    type: String,
    required: false,
  },
},
  setup(__props) {



const getOffset = (tiles: Array<IIndexTile>, idx: number) => {
  if (!tiles) {
    return 0;
  }
  const offset = tiles.slice(0, idx).reduce((acc, curVal) => {
    return acc + (curVal.showAsDouble ? 1 : 0);
  }, 0);
  return offset;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.content, (tile, idx) => {
    return (_openBlock(), _createElementBlock(_Fragment, {
      key: tile.index
    }, [
      (tile.tileType == _unref(TileType).ProductTile)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["col col-6 col-md-4 col-xl-3 col-xxl-2-4 product-listings__container", {
        'product-listings__container--no-border': (idx + 1 + getOffset(__props.content, idx)) % 2 == 0,
        'product-listings__container--no-border-md': (idx + 1 + getOffset(__props.content, idx)) % 3 == 0,
        'product-listings__container--no-border-xl': (idx + 1 + getOffset(__props.content, idx)) % 4 == 0,
        'product-listings__container--no-border-xxl': (idx + 1 + getOffset(__props.content, idx)) % 5 == 0,
        'product-tile--external': (tile as ProductTile).isExternal,
      }])
          }, [
            _createVNode(TressProductTile, {
              "blue-site-logotype": __props.blueSiteLogotype,
              "fast-delivery-logotype": __props.fastDeliveryLogotype,
              "fast-delivery-alt-text": __props.fastDeliveryAltText,
              content: tile as ProductTile,
              index: idx,
              "show-as-b2b": __props.showAsB2b,
              small: false
            }, null, 8, ["blue-site-logotype", "fast-delivery-logotype", "fast-delivery-alt-text", "content", "index", "show-as-b2b"])
          ], 2))
        : (tile.tileType == _unref(TileType).ProductContentTile)
          ? (_openBlock(), _createBlock(TressProductContentTile, {
              key: 1,
              tile: tile as IProductContentTile,
              index: idx
            }, null, 8, ["tile", "index"]))
          : _createCommentVNode("", true)
    ], 64))
  }), 128))
}
}

})